import { getAxiosBackendApi3 } from "../helpers/axios"

class PilgrimageServices{

    constructor(){
    }

    addSacrificer(data){
        return getAxiosBackendApi3().post('sacrificers', data)
    }
}

export default new PilgrimageServices()